import { styled, Box } from '@mui/material';

export const UserboxDaysLeftWarningWrapper = styled(Box)(
  ({ theme }) => `
  display: grid;
  grid-template-columns: repeat(2, auto);
  align-items: baseline;
  column-gap:${theme.spacing(1)};
`
);

export const UserboxDaysLeftWarningText = styled(Box)`
  display: flex;
`;
